import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Check, Monitor, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useTheme, type ThemePreference } from "@/app/theme/context";
import { IconButton } from "@/components/ui/IconButton";

const OPTIONS: { value: ThemePreference; icon: typeof Sun }[] = [
  { value: "light", icon: Sun },
  { value: "dark", icon: Moon },
  { value: "system", icon: Monitor },
];

export function ThemeMenu() {
  const { t } = useTranslation();
  const { preference, resolved, setPreference } = useTheme();
  const TriggerIcon = resolved === "dark" ? Moon : Sun;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton label={t("theme.label")}>
          <TriggerIcon className="size-[1.15rem]" aria-hidden="true" />
        </IconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="z-50 min-w-44 rounded-card border border-line bg-surface p-1.5 shadow-pop"
        >
          <DropdownMenu.Label className="px-2.5 py-1.5 text-xs font-medium text-ink-subtle">
            {t("theme.label")}
          </DropdownMenu.Label>
          <DropdownMenu.RadioGroup
            value={preference}
            onValueChange={(value) => setPreference(value as ThemePreference)}
          >
            {OPTIONS.map(({ value, icon: Icon }) => (
              <DropdownMenu.RadioItem
                key={value}
                value={value}
                className="flex h-9 cursor-default items-center gap-2.5 rounded-control px-2.5 text-sm outline-none select-none data-[highlighted]:bg-sunken"
              >
                <Icon className="size-4 text-ink-muted" aria-hidden="true" />
                <span className="flex-1">{t(`theme.${value}`)}</span>
                <DropdownMenu.ItemIndicator>
                  <Check className="size-4 text-primary" aria-hidden="true" />
                </DropdownMenu.ItemIndicator>
              </DropdownMenu.RadioItem>
            ))}
          </DropdownMenu.RadioGroup>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
